'use client';

import Link from '@eliadmin/core/src/components/link';

import { Button } from '@eliadmin/core/src/components/ui/button';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { FaRegUserCircle } from 'react-icons/fa';

type HeaderProfileButtonProps = {
  className?: {
    profile?: string;
  };
  width?: {
    full?: boolean;
    fit?: boolean;
  };
  order?: number;
};

export const HeaderProfileButton = ({ className, order, width }: HeaderProfileButtonProps) => {
  const me = useCustomerStore(s => s.me);

  return (
    <>
      {me && (
        <Button asChild variant={'secondary'} className={cn(width?.full ? 'w-full' : 'w-fit')}>
          <Link prefetch={false} href={ROUTES.PROFILE()}>
            <FaRegUserCircle size={20} className="text-foreground" />
            <p className="text-sm font-normal text-foreground sm:text-base">
              {me.customer.name} {me.customer.surname.charAt(0)}.
            </p>
          </Link>
        </Button>
      )}
    </>
  );
};
